// Trunkering + smooth toggle av term-beskrivning på produkt-taxonomi-arkiv.
// CSS klampar till 4 rader via max-h-[4lh]; JS animerar max-height mellan
// klamphöjd och scrollHeight.
//
// Både knappen och fadningen längst ner är "det finns mer att läsa"-signaler och
// visas därför bara när texten faktiskt trunkeras. Fadningen renderas som
// default i PHP (så lång text får signalen även utan JS) och döljs här när den
// inte behövs. Kontrollen görs om vid resize — samma text kan få plats på bred
// skärm men klampas på smal.
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-term-description]').forEach(function (wrap) {
        const text = wrap.querySelector('[data-term-description-text]')
        const btn = wrap.querySelector('[data-term-description-toggle]')
        if (!text || !btn) return

        const fade = wrap.querySelector('[data-term-description-fade]')
        let expanded = false

        // Säkerhetsmarginal mot rundningsfel i scrollHeight/clientHeight.
        // Giltig endast i hopfällt läge: expanderat är max-height släppt och
        // scrollHeight === clientHeight.
        function isClamped() {
            return text.scrollHeight > text.clientHeight + 1
        }

        function syncAffordances() {
            if (expanded) return
            const clamped = isClamped()
            btn.classList.toggle('hidden', !clamped)
            if (fade) fade.classList.toggle('hidden', !clamped)
        }

        syncAffordances()

        let resizeTimer
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer)
            resizeTimer = setTimeout(syncAffordances, 150)
        })

        function onTransitionEnd(e) {
            if (e.propertyName !== 'max-height') return
            // Vid expanderat tillstånd: släpp max-height så innehållet kan reflowa
            // (t.ex. vid window resize) utan att klippas.
            if (expanded) text.style.maxHeight = 'none'
            text.removeEventListener('transitionend', onTransitionEnd)
        }

        btn.addEventListener('click', function () {
            text.removeEventListener('transitionend', onTransitionEnd)

            if (!expanded) {
                text.classList.add('expanded')
                // Expandera: animera från nuvarande klamphöjd till full scrollHeight.
                text.style.maxHeight = text.clientHeight + 'px'
                // Force reflow så att övergången ser startvärdet.
                void text.offsetHeight
                text.style.maxHeight = text.scrollHeight + 'px'
            } else {
                text.classList.remove('expanded')
                // Fäll ihop: börja från nuvarande full höjd och animera ner till klamp.
                text.style.maxHeight = text.scrollHeight + 'px'
                void text.offsetHeight
                text.style.maxHeight = '' // tomt = fall tillbaka till CSS (max-h-[4lh])
            }

            text.addEventListener('transitionend', onTransitionEnd)

            expanded = !expanded
            btn.querySelector('span').textContent = expanded ? btn.dataset.labelLess : btn.dataset.labelMore
            btn.setAttribute('aria-expanded', expanded ? 'true' : 'false')
        })
    })
})
